"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidator = exports.getDocType = exports.IDENTIFICATION_DOCUMENT_TYPES = exports.validatorList = void 0;
const NUMBERS_ONLY_REGEX = /^[0-9]+$/;
const LAND_PHONE_REGEX = /^[8|9][0-9]{8}$/;
const MOBILE_PHONE_REGEX = /^[6|7][0-9]{8}$/;
const ANY_PHONE_REGEX = /^[6|7|8|9][0-9]{8}$/;
const DNI_REGEX = /^(\d{8})([A-Z])$/;
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const PASSPORT_REGEX = /^[A-PR-WY0-9]{6,18}$/;
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@ñ"]+(\.[^<>()[\]\\.,;:\s@ñ"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const DTS_TEXT_REGEX = /([^\r\n+|\r+|\n+|\t+])*/;
const DTS_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@ñ"À-ÿ]+(\.[^<>()[\]\\.,;:\s@ñ"À-ÿ]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const DTS_PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]){8,100}$/;
exports.validatorList = {
    REQUIRED: 'required',
    LENGTH: 'length',
    CHECKBOX: 'checkbox',
    NUMBERS_ONLY: 'numbersOnly',
    PHONE: 'phone',
    MOBILE_PHONE: 'mobilePhone',
    ANY_PHONE: 'anyPhone',
    DOC_NUMBER: 'docNumber',
    PATTERN: 'pattern',
    EMAIL: 'email',
    IBAN: 'iban',
    DTS_TEXT: 'dtsText',
    DTS_EMAIL: 'dtsEmail',
    DTS_PASSWORD: 'dtsPassword',
};
const errorTexts = {
    // Required message
    inputRequiredMessage: 'Por favor, rellena este campo',
    // Length messages
    lengthExactMessage: 'El campo debe tener',
    lengthMinMessage: 'El campo debe tener al menos',
    lengthMaxMessage: 'El campo debe tener máximo',
    characterWord: 'caracteres',
    // Checkbox message
    checkboxRequiredMessage: 'Este campo es obligatorio',
    // NumbersOnly message
    invalidNumbersOnlyMessage: 'Tan sólo se permiten números',
    // Phone messages
    phoneInvalidFormat: 'Número fijo no válido',
    mobilePhoneInvalidFormat: 'Número móvil no válido',
    anyPhoneInvalidFormat: 'Número de teléfono no válido',
    // DocTypes messages
    validDocTypesMessage: 'Se permiten los tipos de documento',
    invalidDocType: 'Tipo de documento no permitido',
    docNumberInvalidFormat: 'Documento incorrecto o formato no válido',
    // Email message
    invalidEmailFormat: 'Correo electrónico no válido',
    // IBAN message
    invalidIBAN: 'IBAN introducido no válido',
    // Invalid formar message
    invalidFormat: 'Formato no válido',
    // Password message
    invalidDTSPasswordMessage: 'Formato no válido: al menos 8 caracteres que contengan una mayúscula, una minúscula y un número.',
};
exports.IDENTIFICATION_DOCUMENT_TYPES = {
    CIF: 'CIF',
    DNI: 'DNI',
    NIE: 'NIE',
    PASSPORT: 'PASSPORT',
};
const validateRequired = (value) => {
    let validated = true;
    let errorMsg = '';
    if (!value) {
        validated = false;
        errorMsg = errorTexts.inputRequiredMessage;
    }
    return { validated, errorMsg };
};
const validateLength = (value, componentProps) => {
    let validated = true;
    let errorMsg = '';
    const { maxLength, minLength } = componentProps;
    if (minLength &&
        maxLength &&
        minLength === maxLength &&
        value.length !== minLength) {
        validated = false;
        errorMsg = `${errorTexts.lengthExactMessage} ${minLength} ${errorTexts.characterWord}`;
    }
    else if (minLength && minLength > 0 && value.length < minLength) {
        validated = false;
        errorMsg = `${errorTexts.lengthMinMessage} ${minLength} ${errorTexts.characterWord}`;
    }
    else if (maxLength && maxLength > 0 && value.length > maxLength) {
        validated = false;
        errorMsg = `${errorTexts.lengthMaxMessage} ${maxLength} ${errorTexts.characterWord}`;
    }
    return { validated, errorMsg };
};
const validateRegex = (value, componentProps, regex, regexErrorMessage) => {
    const { required } = componentProps;
    let validated = true;
    let errorMsg = '';
    if (!value) {
        if (!required) {
            return { validated, errorMsg };
        }
        return { validated: false, errorMsg: errorTexts.inputRequiredMessage };
    }
    if (value) {
        validated = regex.test(value);
        if (!validated) {
            errorMsg = regexErrorMessage;
        }
    }
    return { validated, errorMsg };
};
const validateCheckbox = (value, componentProps) => {
    const { required } = componentProps;
    let validated = true;
    let errorMsg = '';
    const newValue = value === true;
    if (!newValue && required) {
        validated = false;
        errorMsg = errorTexts.checkboxRequiredMessage;
    }
    return { validated, errorMsg };
};
const numbersOnlyValidation = (value, componentProps) => {
    return validateRegex(value, componentProps, NUMBERS_ONLY_REGEX, errorTexts.invalidNumbersOnlyMessage);
};
const validatePhone = (value, componentProps) => {
    return validateRegex(value, componentProps, LAND_PHONE_REGEX, errorTexts.phoneInvalidFormat);
};
const validateMobilePhone = (value, componentProps) => {
    return validateRegex(value, componentProps, MOBILE_PHONE_REGEX, errorTexts.mobilePhoneInvalidFormat);
};
const validateAnyPhone = (value, componentProps) => {
    return validateRegex(value, componentProps, ANY_PHONE_REGEX, errorTexts.anyPhoneInvalidFormat);
};
const validDNI = (docNumber) => {
    const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const letter = dniLetters.charAt(parseInt(docNumber, 10) % 23);
    return letter === docNumber.charAt(8);
};
const validNIE = (docNumber) => {
    // Change the initial letter for the corresponding number and validate as DNI
    let niePrefix = docNumber.charAt(0);
    switch (niePrefix) {
        case 'X':
            niePrefix = 0;
            break;
        case 'Y':
            niePrefix = 1;
            break;
        case 'Z':
            niePrefix = 2;
            break;
        default:
    }
    return validDNI(niePrefix + docNumber.substr(1));
};
const validCIF = (docNumber) => {
    const match = docNumber.match(CIF_REGEX);
    const letter = match[1];
    const number = match[2];
    const control = match[3];
    let evenSum = 0;
    let oddSum = 0;
    let n;
    for (let i = 0; i < number.length; i += 1) {
        n = parseInt(number[i], 10);
        // Odd positions (Even index equals to odd position. i=0 equals first position)
        if (i % 2 === 0) {
            // Odd positions are multiplied first.
            n *= 2;
            // If the multiplication is bigger than 10 we need to adjust
            oddSum += n < 10 ? n : n - 9;
            // Even positions
            // Just sum them
        }
        else {
            evenSum += n;
        }
    }
    const controlDigit = (10 - ((evenSum + oddSum) % 10)) % 10;
    const controlLetter = 'JABCDEFGHI'.substr(controlDigit, 1);
    // Control must be a digit
    if (letter.match(/[ABEH]/)) {
        // eslint-disable-next-line eqeqeq
        return control == controlDigit;
        // Control must be a letter
    }
    if (letter.match(/[KPQS]/)) {
        // eslint-disable-next-line eqeqeq
        return control == controlLetter;
        // Can be either
    }
    // eslint-disable-next-line eqeqeq
    return control == controlDigit || control == controlLetter;
};
const getDocType = (docNumber) => {
    const docNumberUpperCase = docNumber.toUpperCase();
    if (docNumberUpperCase.match(DNI_REGEX)) {
        return exports.IDENTIFICATION_DOCUMENT_TYPES.DNI;
    }
    if (docNumberUpperCase.match(NIE_REGEX)) {
        return exports.IDENTIFICATION_DOCUMENT_TYPES.NIE;
    }
    if (docNumberUpperCase.match(CIF_REGEX)) {
        return exports.IDENTIFICATION_DOCUMENT_TYPES.CIF;
    }
    if (docNumberUpperCase.match(PASSPORT_REGEX)) {
        return exports.IDENTIFICATION_DOCUMENT_TYPES.PASSPORT;
    }
    return null;
};
exports.getDocType = getDocType;
const validateDocTypeFormat = (value) => {
    // Ensure upcase and remove whitespace
    const docNumberUpperCase = value.toUpperCase();
    let valid = false;
    const type = (0, exports.getDocType)(docNumberUpperCase);
    switch (type) {
        case exports.IDENTIFICATION_DOCUMENT_TYPES.DNI:
            valid = validDNI(docNumberUpperCase);
            break;
        case exports.IDENTIFICATION_DOCUMENT_TYPES.NIE:
            valid = validNIE(docNumberUpperCase);
            break;
        case exports.IDENTIFICATION_DOCUMENT_TYPES.CIF:
            valid = validCIF(docNumberUpperCase);
            break;
        case exports.IDENTIFICATION_DOCUMENT_TYPES.PASSPORT:
            valid = true;
            break;
        default:
    }
    return valid;
};
const docNumberValidation = (value, componentProps) => {
    let validated = true;
    let errorMsg = '';
    const { allowDocTypes, required } = componentProps;
    if (!value && !required) {
        return { validated, errorMsg };
    }
    const docType = (0, exports.getDocType)(value);
    const docTypeFormatValidation = validateDocTypeFormat(value);
    if (allowDocTypes) {
        if (Object.values(allowDocTypes).includes(docType) &&
            docTypeFormatValidation) {
            validated = true;
        }
        else if (!docTypeFormatValidation) {
            validated = false;
            errorMsg = errorTexts.docNumberInvalidFormat;
        }
        else {
            validated = false;
            const docTypeNames = [];
            Object.keys(allowDocTypes).forEach((docTypeKey) => {
                if (exports.IDENTIFICATION_DOCUMENT_TYPES[allowDocTypes[docTypeKey]]) {
                    docTypeNames.push(exports.IDENTIFICATION_DOCUMENT_TYPES[allowDocTypes[docTypeKey]]);
                }
            });
            errorMsg = `${errorTexts.validDocTypesMessage} ${docTypeNames.join(' / ')}`;
        }
    }
    else {
        validated = false;
        errorMsg = errorTexts.invalidDocType;
    }
    return { validated, errorMsg };
};
const validatePattern = (value, componentProps, pattern) => {
    const regexPattern = new RegExp(pattern);
    return validateRegex(value, componentProps, regexPattern, errorTexts.invalidFormat);
};
const validateEmail = (value, componentProps) => {
    return validateRegex(value, componentProps, EMAIL_REGEX, errorTexts.invalidEmailFormat);
};
const validateIBAN = (value) => {
    let validated = true;
    let errorMsg = '';
    // Validate IBAN algorithm (ISO 7604):
    //   - Rearrange: move the four initial characters to the end of the string
    //   - Numeric: replace each letter in the string with two digits, where A = 10, B = 11, ..., Z = 35
    //   - Remainder: if the remainder of that number on division by 97 is 1, the IBAN is valid
    const rearranged = value.substring(4, value.length) + value.substring(0, 4);
    const numeric = Array.from(rearranged.toUpperCase())
        .map(function (c) {
        return isNaN(parseInt(c)) ? (c.charCodeAt(0) - 55).toString() : c;
    })
        .join('');
    const remainder = Array.from(numeric)
        .map(function (c) {
        return parseInt(c);
    })
        .reduce(function (remainder, value) {
        return (remainder * 10 + value) % 97;
    }, 0);
    if (remainder !== 1) {
        validated = false;
        errorMsg = errorTexts.invalidIBAN;
    }
    return { validated, errorMsg };
};
/* START SPECIFIC DTS VALIDATORS */
const validateDTSText = (value, componentProps) => {
    const textTrimmed = value.trim();
    return validateRegex(textTrimmed, componentProps, DTS_TEXT_REGEX, errorTexts.invalidFormat);
};
const validateDTSEmail = (value, componentProps) => {
    return validateRegex(value, componentProps, DTS_EMAIL_REGEX, errorTexts.invalidEmailFormat);
};
const validateDTSPassword = (value, componentProps) => {
    return validateRegex(value, componentProps, DTS_PASSWORD_REGEX, errorTexts.invalidDTSPasswordMessage);
};
/* END SPECIFIC DTS VALIDATORS */
/* Validator mapping begin */
const getValidator = (type) => {
    switch (type) {
        case exports.validatorList.REQUIRED:
            return validateRequired;
        case exports.validatorList.LENGTH:
            return validateLength;
        case exports.validatorList.NUMBERS_ONLY:
            return numbersOnlyValidation;
        case exports.validatorList.CHECKBOX:
            return validateCheckbox;
        case exports.validatorList.PHONE:
            return validatePhone;
        case exports.validatorList.MOBILE_PHONE:
            return validateMobilePhone;
        case exports.validatorList.ANY_PHONE:
            return validateAnyPhone;
        case exports.validatorList.DOC_NUMBER:
            return docNumberValidation;
        case exports.validatorList.PATTERN:
            return validatePattern;
        case exports.validatorList.EMAIL:
            return validateEmail;
        case exports.validatorList.IBAN:
            return validateIBAN;
        case exports.validatorList.DTS_TEXT:
            return validateDTSText;
        case exports.validatorList.DTS_EMAIL:
            return validateDTSEmail;
        case exports.validatorList.DTS_PASSWORD:
            return validateDTSPassword;
        default:
            return null;
    }
};
exports.getValidator = getValidator;
/* Validator mapping end */
//# sourceMappingURL=index.js.map